import dynamic from 'next/dynamic';
import { ComponentConfig } from '@zapier/builder-io-kit-compat';

export const config: ComponentConfig = {
  name: 'Feature Item',
  description: 'Renders a feature bullet inside <FeatureItemList>.',
  category: 'Zapier Sign Up Blocks',
  // @ts-ignore
  component: dynamic(() =>
    import('@zapier/auth-pages').then(mod => mod.FeatureItem)
  ),
  inputs: [
    {
      name: 'content',
      friendlyName: 'Content',
      type: 'string',
      defaultValue: '',
    },
  ],
};
